import { type ReactElement } from 'react';
import { useRouteError } from 'react-router-dom';

interface Props {
    from?: string;
}

export default function ErrorPage(props: Props): ReactElement {
    const { from } = props;

    const error: any = useRouteError();
    console.error(error);

    return (
        <div id="error-page">
            <strong>This is Error page contents</strong>
            <p>Unexpected error has occurred from {from ?? '🔥 somewhere 🔥'}</p>
            <p>
                <i>{error?.statusText ?? error?.message ?? 'no error? messages'}</i>
            </p>
        </div>
    );
}
